var map = {
	"./advantages.png": "1787",
	"./cases.jpg": "1689",
	"./hands-with-keyboard.png": "e412",
	"./hands.png": "507a",
	"./hands2.png": "3f19",
	"./man.png": "266b",
	"./man2.png": "0869",
	"./record.png": "9707",
	"./skype.png": "8919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "738b";